import { Box } from "../../../CommonComponents/OPL/Box/Box";
import styled from "../../../theme/theme";

export const Container = styled(Box)<{ isEmbeddedMobile: boolean }>(({ theme, isEmbeddedMobile }) => ({
  flex: 1,
  borderBottom: isEmbeddedMobile ? `1px solid ${theme.colors.neutral[200]}` : '0',
  borderTop: isEmbeddedMobile ? `1px solid ${theme.colors.neutral[200]}` : '0',
  '> *': {
    padding: theme.space['12'],
  },
  '> * + *': {
    borderTop: isEmbeddedMobile ? `1px solid ${theme.colors.neutral[200]}` : '0',
  },
}));